import { publicRoutes, authenticatedRoutes } from "./public.routes";
import { adminRoutes } from "./admin.routes";
import { fieldRoutes } from "./field.routes";
import { errorRoutes } from "./error.routes";
import type { ExtendedRouteObject } from "./types";

export type { ExtendedRouteObject, RouteScope, RouteRule } from "./types";

export const routes: ExtendedRouteObject[] = [
  ...publicRoutes,
  ...authenticatedRoutes,
  ...fieldRoutes,
  ...adminRoutes,
  ...errorRoutes,
];
